import type { WalletBalance } from "../../lib/api";
import { formatTokenAmount } from "../../lib/format";

const DISPLAY_DIGITS: Record<string, number> = {
	WBTC: 6,
	ETH: 4,
};

export function BalancePill({ balance }: { balance: WalletBalance }) {
	if (balance.error) {
		return (
			<span
				className="rounded-md border border-amber-900/40 bg-amber-950/30 px-2 py-1 text-[11px] text-amber-300"
				title={balance.error}
			>
				{balance.symbol} <span className="text-amber-200/60">n/a</span>
			</span>
		);
	}
	const display = formatTokenAmount(
		balance.rawBalance,
		balance.decimals,
		DISPLAY_DIGITS[balance.symbol] ?? 2,
	);
	return (
		<span className="flex items-baseline gap-1 rounded-md border border-slate-800 bg-slate-950/60 px-2 py-1 text-[11px]">
			<span className="text-[10px] uppercase tracking-wide text-slate-500">
				{balance.symbol}
			</span>
			<span className="font-mono text-slate-100">{display}</span>
		</span>
	);
}
